module.exports = __webpack_public_path__ + "img/add-class.571184b1.png";